import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Phone(props) {
    return (
        <SvgIcon {...props}>
            <path d="M23.5 30c-.4 0-1-.1-1.8-.2s-1.9-.4-3.1-.9c-1.2-.5-2.6-1.3-4.1-2.3-1.5-1-3.2-2.4-4.9-4.2-1.4-1.4-2.5-2.7-3.4-3.9-.9-1.2-1.6-2.4-2.2-3.5-.6-1.1-1-2-1.2-2.9-.3-.9-.5-1.6-.6-2.2C2 9.3 2 8.8 2 8.5v-.7c0-.3.1-.5.3-.8.1-.3.3-.5.5-.7l3.9-3.9c.3-.3.6-.4 1-.4H8l.3.2c.2.1.3.3.5.5l.1.1 3.1 6c.2.3.2.7.1 1-.1.4-.2.7-.5 1l-1.5 1.5c-.1.1-.1.2-.1.2v.2c.1.4.3.9.5 1.4.2.5.6 1.1 1.1 1.7.5.7 1.2 1.5 2.1 2.4.9.9 1.7 1.6 2.4 2.1s1.3.9 1.7 1.1.8.4 1.1.4l.4.1h.2s.1 0 .2-.1l1.7-1.7c.4-.4.8-.5 1.3-.5.3 0 .5 0 .7.1l5.8 3.4c.4.2.6.5.7.9v.2c0 .4-.1.8-.4 1.1l-3.9 3.9c-.2.2-.4.4-.7.5-.3.1-.5.2-.8.3H23.5zM4 8.1v.5c0 .1 0 .4.1 1 .1.5.2 1.2.5 1.9.2.7.6 1.6 1.1 2.6.5 1 1.2 2 2 3.2.8 1.2 1.9 2.4 3.2 3.7 1.6 1.7 3.2 3 4.6 3.9 1.4.9 2.7 1.6 3.8 2.1 1.1.4 1.9.7 2.6.8 1.2.2 1.5.2 1.6.2l.8-.3 3.2-3.2-4.9-2.9-1.5 1.6c-.3.3-.6.5-1 .6-.1 0-.5.1-.8.1H19l-.5-.1c-.4-.1-.9-.3-1.6-.6-.6-.3-1.2-.7-2-1.3-.8-.6-1.6-1.3-2.6-2.3-1-1-1.7-1.8-2.3-2.6-.6-.8-1-1.4-1.3-2-.4-.7-.6-1.3-.7-2v-.3c0-.4 0-.7.1-1 .1-.4.3-.7.6-1L10 9.4l-2.6-5-3.3 3.4v.1c0 .1-.1.2-.1.2zm6.3 1.6c0 .1 0 .1 0 0z" />
        </SvgIcon>
    );
}

Phone.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Phone;
